module.exports = __webpack_public_path__ + "static/img/yidong.37b51e91.png";